import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../model/rootReducer'
import { createLoadingSelector } from '../../../business/selectors/loadingSelectors'
import Loader from '../../system/loader/Loader'
import ItemManager from '../../system/itemManager/ItemManager'
import { DialogTranscription } from '../../../model/transcription/types'
import TranscriptionList from './transcriptionList/TranscriptionList'
import { Container } from './Styled'
import TranscriptionDetails from './transcriptionDetails/TranscriptionDetails'
import BuilderLayout from '../../layouts/builderLayout/BuilderLayout'
//@ts-ignore
import { ReactComponent as Svg } from './message.svg'

const DialogTranscriptionItemManager = ItemManager<DialogTranscription>()

type IntentFormProps = {}

const Transcription: React.FunctionComponent<IntentFormProps> = (props) => {
  const [
    selectedDialogTranscription,
    setSelectedDialogTranscription,
  ] = useState<DialogTranscription | undefined | null>(null)
  const loadingSelector = createLoadingSelector([
    'FILL_TRANSCRIPTION_SPEECH',
    'FILL_TRANSCRIPTIONS',
  ])
  const isFetching = useSelector((state: RootState) => loadingSelector(state))
  const transcriptions = useSelector(
    (state: RootState) => state.transcription.transcriptions
  )
  const transcription = transcriptions.find(
    (dialog) => dialog.id === selectedDialogTranscription?.id
  )

  const renderMenu = () => {
    return (
      <TranscriptionList
        transcriptions={transcriptions}
        selectedDialogTranscriptionId={selectedDialogTranscription?.id}
        onSelect={(dialogTranscription?: DialogTranscription | null) =>
          setSelectedDialogTranscription(dialogTranscription)
        }
      />
    )
  }

  const renderContent = () => {
    return <TranscriptionDetails transcription={transcription!} />
  }
  return (
    <BuilderLayout
      onBackDestination="/"
      title={'Transcription'}
      subTitle={'Consultez les transcriptions de votre agent conversationnel'}
    >
      <Loader isLoading={isFetching}>
        <Container>
          <DialogTranscriptionItemManager
            emptyDescription="Veuillez sélectionner une conversation pour en consulter le contenu"
            EmptyImage={<Svg />}
            Menu={renderMenu()}
            Content={renderContent()}
            selectedItem={transcription ? transcription : null}
          />
        </Container>
      </Loader>
    </BuilderLayout>
  )
}

export default Transcription
